<div class="summaryModal">
	<h1 mat-dialog-title>Palveluntarjoajat</h1>
	<div mat-dialog-content class="carSpecSummaryModal">
	    <div *ngIf="!leasingCriteria.monthlyFee">
	        <div class="strong searchResult">
	            Palveluntarjoajat:
	            <br />
	            <div class="customers">
	                <span *ngFor="let customer of searchResult.customers; let customerIndex = index;">
	                    <span class="item">{{ customer.name }}</span>
	                    <span *ngIf="customerIndex < searchResult.customers.length - 1">, </span>
	                </span>
	            </div>
	        </div>
	    </div>
	    <div *ngIf="leasingCriteria.monthlyFee">
	        <div class="carSpec" *ngFor="let carSpec of leasingCriteria.carSpecs; let i = index;">
	            <h3 class="blue">{{ (i + 1) + '. auton tiedot: ' }}</h3>
	            <p class="strong blue" *ngIf="carSpec.make">
	                {{carSpec.make.name}} <span *ngIf="carSpec.model">{{carSpec.model.name}}</span>
	            </p>
	            <p *ngIf="carSpec.contractLength">Sopimusaika: {{carSpec.contractLength}} kk</p>
	            <p *ngIf="carSpec.contractMileage">Ajokilometrit / vuosi: {{carSpec.contractMileage}} km</p>
	            <p *ngIf="carSpec.bodyType">Korimalli: {{carSpec.bodyType.name}} </p>
	            <p *ngIf="carSpec.fuelType">Käyttövoima {{carSpec.fuelType.name}} </p>
	            <p *ngIf="carSpec.services.length > 0">Leasing-palvelut: {{ carSpec.serviceNameAsString }} </p>
	            <p *ngIf="carSpec.additionalInformation">Toiveet autostat: <br />{{carSpec.additionalInformation}} </p>
	            <div class="strong searchResult">
	                Palveluntarjoajat:
	                <br />
	                <div class="customers">
	                    <span *ngFor="let customer of carSpec.searchResult.customers; let customerIndex = index;">
	                        <span class="item">{{ customer.name }}</span>
	                        <span *ngIf="customerIndex < carSpec.searchResult.customers.length - 1">, </span>
	                    </span>
	                </div>
	            </div>
	            <mat-divider *ngIf="i < leasingCriteria.carSpecs.length - 1"></mat-divider>
	        </div>
	    </div>
	</div>
	<div mat-dialog-actions align="end">
	    <span class="orange button" (click)="close()" cdkFocusInitial>SULJE</span>
	</div>
</div>	